import React, { useState, useEffect, useContext } from 'react';
import '../KPI.css';
import AuthContext from 'contexte/AuthContext';
import DateSelector from 'components/Filters/DateSelector/DateSelector';
import { Box } from '../KpiBox/KpiBox';
import { fetchKpiDataForDates } from 'services/kpiServices';
import { MARGIN_RELEASE_DATE, RELEASE_DATE } from 'utils/date';

const getDefaultKpiDatas = () => ({
  gains: 0,
  avg_trade_per_client: 0,
  unique_clients: 0,
  clients_profit_loss: 0,
  volumes: [],
  trades_count: 0,
  deposits: 0
})

const Kpi = () => {
  const { user } = useContext(AuthContext);
  const [kpiData, setKpiData] = useState({
    selectedData: getDefaultKpiDatas(),
    comparedData: getDefaultKpiDatas()
  });
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(MARGIN_RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchKpiDataForDates(user, selectedDate.date1, selectedDate.date2);
      setKpiData(data);
    };
    fetchData();
  }, [user, selectedDate]);

  return (

    <div>
      <div className='kpi_date'>
        <DateSelector selectedDate={selectedDate} setSelectedDate={setSelectedDate} withComparaison={true} />
      </div>
      <div className='kpi_container'>
        {
          kpiData?.selectedData?.volumes?.map(({ currency, volume }) => {
            const comparedData = kpiData.comparedData?.volumes?.find(({ comparedCurrency }) => comparedCurrency === currency);

            return <Box
              key={currency}
              title={`Volume ${currency}`}
              data={volume}
              unit='€'
              comparedData={comparedData?.volume}
              link='/finances/margin-transactions'
            />
          })

        }
        <Box
          title='Gains'
          data={kpiData.selectedData.gains}
          comparedData={kpiData.comparedData.gains}
          unit='€'
        />
        <Box
          title='Investisseurs unique'
          data={kpiData.selectedData.unique_clients}
          comparedData={kpiData.comparedData.unique_clients}
        />
        <Box
          title='Clients PL'
          data={kpiData.selectedData.clients_profit_loss}
          comparedData={kpiData.comparedData.clients_profit_loss}
          unit='€'
        />
        <Box
          title='Trades/Client'
          data={kpiData.selectedData.avg_trade_per_client}
          comparedData={kpiData.comparedData.avg_trade_per_client}
        />
        <Box
          title=' Nombre de Trades'
          data={kpiData.selectedData.trades_count}
          comparedData={kpiData.comparedData.trades_count}
        />
        <Box
          title=' Dépôts'
          data={kpiData.selectedData.deposits}
          comparedData={kpiData.comparedData.deposits}
        />
      </div>
    </div>
  )
}


export default Kpi